import React, { useEffect } from 'react';
import { Prospect } from '../../shared/types';
import { cronogramaObraCliente } from '../../shared/data/arquiteturaData';
import { Compass, HardHat, Camera, FileText, CheckCircle2, Clock, ChevronRight, Bell } from 'lucide-react';

export const ArchApp: React.FC<{ prospect: Prospect }> = ({ prospect }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-stone-900 flex items-center justify-center p-4 font-sans text-stone-900">
      <div className="w-[390px] h-[844px] bg-[#FAF9F6] rounded-[2.5rem] relative overflow-hidden border-[12px] border-stone-800 flex flex-col justify-between">
        
        {/* Top Header App / Obra Status */}
        <div>
           {/* Top Status Bar */}
           <div className="h-12 flex items-center justify-between px-8 text-xs font-medium pt-2 text-stone-600">
              <span>11:15</span>
              <div className="flex gap-1.5 items-center">
                 <div className="w-4 h-3 bg-current rounded-sm"></div>
                 <div className="w-3 h-3 bg-current rounded-full"></div>
              </div>
           </div>

           <div className="px-6 pt-2 pb-4">
              <div className="flex justify-between items-center mb-6">
                 <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-xl bg-[#1A1A1A] text-[#D4C5B9] flex items-center justify-center font-black">
                       <Compass className="w-5 h-5" />
                    </div>
                    <div>
                       <p className="text-[10px] text-stone-500 uppercase tracking-widest font-bold">Diário de Bordo da Obra</p>
                       <h1 className="font-heading font-bold text-sm text-[#1A1A1A]">{prospect.trade_name}</h1>
                    </div>
                 </div>
                 <div className="w-9 h-9 rounded-xl bg-white border border-stone-300 flex items-center justify-center text-stone-700">
                    <Bell className="w-4 h-4" />
                 </div>
              </div>

              {/* Card Resumo do Projeto - STRICT NO SHADOWS */}
              <div className="bg-[#1A1A1A] text-white p-5 rounded-xl mb-6 border border-stone-800">
                 <div className="flex justify-between items-start mb-3">
                    <span className="bg-[#C86D51] text-white px-2.5 py-0.5 rounded text-[10px] font-bold uppercase">Obra em Andamento</span>
                    <span className="text-[10px] text-stone-400 font-mono">680 m²</span>
                 </div>
                 <h4 className="font-bold text-sm text-white mb-1">Casa Gabriel — Jardins</h4>
                 <p className="text-[10px] text-stone-400 font-light mb-4">Etapa 2 de 4 • Previsão de Entrega: 15/Nov</p>
                 
                 {/* Barra de Progresso da Obra */}
                 <div>
                    <div className="flex justify-between text-[10px] text-stone-400 mb-1 font-bold">
                       <span>Evolução Geral da Reforma</span>
                       <span className="text-[#D4C5B9]">68%</span>
                    </div>
                    <div className="w-full h-2 bg-stone-800 rounded-full overflow-hidden">
                       <div className="h-full bg-[#C86D51]" style={{ width: '68%' }}></div>
                    </div>
                 </div>
              </div>

              {/* Etapas do Cronograma - STRICT NO SHADOWS */}
              <h3 className="font-heading font-bold text-xs uppercase tracking-wider text-stone-500 mb-3">Linha do Tempo da Reforma</h3>
              <div className="space-y-3">
                 {cronogramaObraCliente.map(stg => (
                    <div key={stg.id} className="bg-white border border-stone-300 p-4 rounded-xl">
                       <div className="flex justify-between items-start mb-2">
                          <h5 className="font-bold text-xs text-[#1A1A1A]">{stg.phase}</h5>
                          <span className={`px-2 py-0.5 rounded text-[9px] font-bold ${stg.status === 'Concluído' ? 'bg-emerald-100 text-emerald-800' : 'bg-amber-100 text-amber-800'}`}>
                             {stg.status}
                          </span>
                       </div>
                       <p className="text-[10px] text-stone-500 font-light leading-snug">{stg.notes}</p>
                    </div>
                 ))}
              </div>

           </div>
        </div>

        {/* Footer App */}
        <div className="p-6 bg-white border-t border-stone-300">
           <button className="w-full bg-[#1A1A1A] text-white py-3 rounded-xl font-bold text-xs uppercase tracking-wider border border-[#1A1A1A] flex items-center justify-center gap-2">
              <Camera className="w-4 h-4 text-[#D4C5B9]" />
              Ver Relatório Fotográfico da Semana
           </button>
        </div>

      </div>
    </div>
  );
};
